import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import PoPrintModal from './PoPrintModal';
import RepairPoServices from "../../../services/RepairPoServices";
import Spinner from 'react-bootstrap/Spinner';
import ReceivedOrderModal from './ReceivedOrderModal';
import * as XLSX from "xlsx";



const PrintPDFRepairPo = () => {
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(true);
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [gridInsideModal, setGridInsideModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [sort, setSort] = useState(20);
    const [searchTerm, setSearchTerm] = useState("");
    const [gridInsideModal2, setGridInsideModal2] = useState(false);
    const [selectedItem2, setSelectedItem2] = useState(null);
    const activePag = useRef(0);
    const [test, setTest] = useState(0);

    const [loading, setLoading] = useState(true);



    const options = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 20, label: '20' },
        { value: 50, label: '50' },
        { value: 100, label: '100' }
    ];

    useEffect(() => {
        const fetchPurchaseOrders = async () => {
            try {
                setLoading(true); // Start loader

                // ✅ Fetch only 'Generated' purchase orders
                const res = await RepairPoServices.AllPOByStatus("Confirmed-Generated");
                const poList = res?.data || [];
                setPurchaseOrders(poList);
            } catch (error) {
                console.error(error);
                Swal.fire("Error", "Failed to fetch purchase orders", "error");
            } finally {
                setLoading(false); // Stop loader
            }
        };

        fetchPurchaseOrders();
    }, [test]); // Optional: use dependency if needed



    const filteredSearch = purchaseOrders.filter((row) => {
        const search = searchTerm.toLowerCase();

        const repairOrderNo =
            row?.repairOrder?.repairOrderNo?.toString().toLowerCase() || "";

        const poNumber =
            row?.poNumber?.toString().toLowerCase() || "";

        const supplierName =
            row?.supplier?.name?.toLowerCase() || "";

        const storeName =
            row?.repairOrder?.store?.name?.toLowerCase() || "";

        const createdBy =
            row?.createdBy?.name?.toLowerCase() || "";

        // 🔹 Search inside ALL items (important)
        const partNos = row?.items
            ?.map(i => i?.partNo?.toString().toLowerCase())
            .join(" ") || "";

        const descriptions = row?.items
            ?.map(i => i?.description?.toLowerCase())
            .join(" ") || "";

        return (
            repairOrderNo.includes(search) ||
            poNumber.includes(search) ||
            supplierName.includes(search) ||
            storeName.includes(search) ||
            createdBy.includes(search) ||
            partNos.includes(search) ||
            descriptions.includes(search)
        );
    });




    const pagination = Math.ceil(filteredSearch.length / sort);

    const onClick = (i) => {
        activePag.current = i;
        setTest(i);
    };

    const handleViewClick = (poDetails) => {
        setSelectedItem(poDetails);       // set item to pass into modal
        setGridInsideModal(true);         // show modal
    };



    const handleViewItem = (e, row) => {
        e.stopPropagation(); // prevent bubbling if inside clickable row
        setSelectedItem2(row);
        setGridInsideModal2(true);
    };

    const exportToExcel = () => {
        if (filteredSearch.length === 0) {
            Swal.fire("No Data", "No Repair Orders found to export!", "info");
            return;
        }

        const dataForExcel = filteredSearch.map((row, index) => ({
            "#": index + 1,

            "Repair Request No":
                row?.repairOrder?.repairOrderNo || "N/A",

            "Reapir Order No":
                row?.poNumber || "N/A",

            "Repair Part No":
                row?.items?.map(i => i?.partNo || "N/A").join(", "),

            "Repair Part Description":
                row?.items?.map(i => i?.description || "N/A").join(", "),

            "Qty":
                row?.items?.map(i => i?.approveQty ?? 0).join(", "),

            "Rate":
                row?.items?.map(i => i?.rate ?? 0).join(", "),

            "Store":
                row?.repairOrder?.store?.name || "N/A",

            "Supplier":
                row?.supplier?.name || "N/A",

            "Supplier Address":
                row?.supplier?.address
                    ? `${row.supplier.address.street || ""}, ${row.supplier.address.city || ""}, ${row.supplier.address.state || ""} - ${row.supplier.address.pincode || ""}, ${row.supplier.address.country || ""}`
                    : "N/A",

            "Created At":
                new Date(row?.createdAt).toLocaleDateString("en-IN"),

            "Items Count":
                row?.items?.length || 0,
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Repair Orders");
        XLSX.writeFile(workbook, "All_Repair_Orders.xlsx");

        Swal.fire("Success", "Repair Orders Excel downloaded successfully!", "success");
    };


    return (
        loading ? (
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner animation="border" role="status" variant="primary" />
                <p className="mt-2 fw-bold text-primary">Loading PO...</p>
            </div>
        ) : (
            <>
                {selectedItem2 && (
                    <ReceivedOrderModal
                        show={gridInsideModal2}
                        handleClose={() => setGridInsideModal2(false)}
                        test={setTest}
                        admin={selectedItem2}
                    />
                )}

                <PoPrintModal
                    show={gridInsideModal}
                    onHide={() => setGridInsideModal(false)}
                    item={selectedItem}
                />
                <div className="row">
                    <div className="col-xl-12">

                        {/* Filter */}
                        <div className="filter cm-content-box box-primary">
                            <div className="content-title">
                                <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
                                <div className="tools">
                                    <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                                        <i className="fas fa-angle-up"></i>
                                    </Link>
                                </div>
                            </div>
                            <Collapse in={open}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-xl-3 col-xxl-6 mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by Repair Request No, Repair No, Part No, Description, Supplier, Store"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-xl-3 col-xxl-6 mb-3">
                                                <Select
                                                    placeholder="Rows per page"
                                                    value={options.find(option => option.value === sort)}
                                                    onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                                                    isSearchable={false}
                                                    options={options}
                                                    className="custom-react-select"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        {/* Table */}
                        <div className="filter cm-content-box box-primary">
                            <div className="content-title">
                                <div className="cpa">
                                    <i className="fa fa-list me-2"></i>All Repair Orders
                                    <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                                </div>
                                <div className="tools">
                                    <Link to="#" className={`SlideToolHeader ${open2 ? 'collapse' : 'expand'}`} onClick={() => setOpen2(!open2)}>
                                        <i className="fas fa-angle-up"></i>
                                    </Link>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={exportToExcel}
                                    >
                                        <i className="fa fa-download me-1"></i>Download Excel
                                    </button>

                                    <div className="tools">
                                        <Link
                                            to="#"
                                            className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                            onClick={() => setOpen2(!open2)}
                                        >
                                            <i className="fas fa-angle-up"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <Collapse in={open2}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div id="content_wrapper" className="dataTables_wrapper no-footer">
                                                <div style={{
                                                    overflowX: 'auto',
                                                    overflowY: 'auto',
                                                    maxHeight: '400px',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                                                        <thead
                                                            style={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "#fff", // White background
                                                                zIndex: 2,
                                                            }}
                                                        >
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Request No.</th>
                                                                <th>Repair Order</th>
                                                                <th>Repair Part No</th>
                                                                <th> Repair Part Description</th>
                                                                <th>Qty</th>
                                                                <th>Rate</th>
                                                                <th>Store</th>
                                                                <th>Suppplier</th>
                                                                <th>Deliver Address</th>
                                                                <th>CreatedAt</th>
                                                                <th>Items</th>
                                                                <th>View Items</th>
                                                                <th>Print</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {filteredSearch.length > 0 ? (
                                                                filteredSearch
                                                                    .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                                                    .map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>{activePag.current * sort + index + 1}</td>
                                                                            <td>{row?.repairOrder?.repairOrderNo || "N/A"}</td>
                                                                            <td>{row?.poNumber || 'N/A'}</td>

                                                                            {/* Repair Part No */}
                                                                            <td>
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>
                                                                                        {item?.partNo || "N/A"}
                                                                                    </div>
                                                                                ))}
                                                                            </td>


                                                                            {/* Repair Part Description */}
                                                                            <td className="scrollable-description">
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>
                                                                                        {item?.description || "N/A"}
                                                                                    </div>
                                                                                ))}
                                                                            </td>

                                                                            <td>
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>{item?.approveQty || 'N/A'}</div>
                                                                                ))}
                                                                            </td>
                                                                            <td>
                                                                                {row?.items?.map((item, idx) => (
                                                                                    <div key={idx}>{item?.rate || 'N/A'}</div>
                                                                                ))}
                                                                            </td>
                                                                            {/* Store */}
                                                                            <td className="scrollable-description">
                                                                                {row?.repairOrder?.store?.name || "N/A"}
                                                                            </td>
                                                                            {/* Supplier */}
                                                                            <td className="scrollable-description">
                                                                                {row?.supplier?.name || "N/A"}
                                                                            </td>
                                                                            {/* Delivery Address */}
                                                                            <td className="scrollable-description">
                                                                                {row?.supplier?.address?.street}, {row?.supplier?.address?.city},
                                                                                <br />
                                                                                {row?.supplier?.address?.state} - {row?.supplier?.address?.pincode},
                                                                                <br />
                                                                                {row?.supplier?.address?.country}
                                                                            </td>
                                                                            <td>{new Date(row?.createdAt).toLocaleDateString('en-IN')}</td>
                                                                            <td>{row?.items?.length || 0}</td>
                                                                            <td><i className="fa fa-eye" onClick={(e) => { handleViewItem(e, row) }}></i>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className="btn btn-success btn-xs"
                                                                                    onClick={() => handleViewClick(row)}
                                                                                >
                                                                                    Print{/*row?.items?.[0]?.supplier?.name || "Unknown Supplier"*/}
                                                                                </button>
                                                                            </td>

                                                                        </tr>
                                                                    ))
                                                            ) : (
                                                                <tr><td colSpan="13" className="text-center">No Purchase Orders Found</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Pagination */}
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div className="dataTables_info">
                                                        Showing {filteredSearch.length > 0 ? (activePag.current * sort + 1) : 0} to{" "}
                                                        {Math.min(filteredSearch.length, (activePag.current + 1) * sort)} of {filteredSearch.length} entries
                                                    </div>
                                                    <div className="dataTables_paginate paging_simple_numbers">
                                                        <Link className="paginate_button previous" to="#" onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}>
                                                            <i className="fa fa-angle-double-left"></i>
                                                        </Link>
                                                        <span>
                                                            {Array.from({ length: pagination }, (_, i) => (
                                                                <Link
                                                                    key={i}
                                                                    to="#"
                                                                    className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                                                    onClick={() => onClick(i)}
                                                                >
                                                                    {i + 1}
                                                                </Link>
                                                            ))}
                                                        </span>
                                                        <Link className="paginate_button next" to="#" onClick={() => activePag.current < pagination - 1 && onClick(activePag.current + 1)}>
                                                            <i className="fa fa-angle-double-right"></i>
                                                        </Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                </div>
            </>
        )
    );
};

export default PrintPDFRepairPo;
